import { styled } from "styled-components";

export const Wrapper = styled.div`
    padding: 30px 20px 20px 40px;
`;